import API from 'services/API';

export default function getTaxpayerCsvLink() {
  return API.request({
    method: 'GET',
    url: '/zipTaxes/csvInfoLink',
    responseType: 'text',
  });
}
